import { render, staticRenderFns } from "./CostPointMapTable.vue?vue&type=template&id=18a37140"
import script from "./CostPointMapTable.vue?vue&type=script&lang=js"
export * from "./CostPointMapTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports